var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSandbox = function SvgSandbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22,
    viewBox: "0 0 22.001 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4140"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4139"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M22.001 21.18a.4.4 0 0 1-.4.407H.401a.407.407 0 0 1 0-.813c4.771 0 4.986.019 13.136 0a7.774 7.774 0 0 1-1.136-4.053v-3.993a.764.764 0 0 1 .779-.747h2.1l-.257-8.606a2.333 2.333 0 0 1 .616-1.672 1.791 1.791 0 0 1 2.651 0 2.331 2.331 0 0 1 .616 1.672l-.257 8.606h2.1a.764.764 0 0 1 .779.747v3.993a7.76 7.76 0 0 1-1.127 4.052h1.2a.4.4 0 0 1 .4.407ZM15.826 3.349l.178 5.981h1.929l.179-5.981a1.507 1.507 0 0 0-.391-1.081 1.026 1.026 0 0 0-1.505 0 1.5 1.5 0 0 0-.39 1.081Zm.2 6.794.156 5.222a.795.795 0 1 0 1.568 0l.157-5.222Zm3.411 10.63a6.937 6.937 0 0 0 1.3-4.053v-3.926h-2.108l-.078 2.594a1.587 1.587 0 1 1-3.165 0l-.078-2.6h-2.107v3.927a6.929 6.929 0 0 0 1.3 4.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.01,
    stroke: "currentcolor",
    strokeLinecap: "round",
    d: "M1.238 20.947s2.393-6.062 3.727-10.095 2.4-5.6 4.912-5.543 3.367 3.45 3.924 4.287",
    "data-name": "Path 11818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    d: "M8.218 17.753h.359",
    "data-name": "Line 249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    d: "M4.241 18.753H4.6",
    "data-name": "Line 250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    d: "M6.23 14.667h.359",
    "data-name": "Line 251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    d: "M7.224 10.617h.359",
    "data-name": "Line 248"
  }))))));
};
export default SvgSandbox;